interface IBuildInternalPostLinkClipboardURLArgs {
    href: string,
    origin: string,
}

/**
 * Builds the user-facing URL copied from an internal post link card.
 * Relative in-app hrefs are expanded against the current page origin so the
 * pasted value works outside the browser session.
 */
const buildInternalPostLinkClipboardURL = ({
    href,
    origin,
}: IBuildInternalPostLinkClipboardURLArgs): string => {
    const normalizedHref = `${href || ''}`.trim();
    const normalizedOrigin = `${origin || ''}`.trim();
    if (!normalizedHref) {
        return '';
    }

    try {
        return new URL(normalizedHref, normalizedOrigin).toString();
    } catch (_error) {
        return normalizedHref;
    }
};

export default buildInternalPostLinkClipboardURL;
